import React from 'react';
import {Route} from 'react-router-dom';
import {Switch} from 'react-router';

import Nps from './containers/Nps';
import Forbidden from './containers/Forbidden';

const Routes = () => {
  return (
      <Switch>
        <Route exact path="/:hash">
          <Nps/>
        </Route>
        <Route path="*">
          <Forbidden/>
        </Route>
      </Switch>
  );
};

export default Routes;
